import { render, staticRenderFns } from "./DashboardNotificationPopup.vue?vue&type=template&id=bb2fe252&scoped=true&"
import script from "./DashboardNotificationPopup.vue?vue&type=script&lang=js&"
export * from "./DashboardNotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotificationPopup.vue?vue&type=style&index=0&id=bb2fe252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2fe252",
  null
  
)

/* custom blocks */
import block0 from "./DashboardNotificationPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports